import { create } from 'zustand'
import type { Vec3 } from './spawn'

// Per-asset normalized bounding-box size, published by Model once its glb loads and read by
// Grabbable to size the collider to the actual model box. Keyed by assetId so duplicate instances
// share one entry; written once (bounds are asset-intrinsic).
interface BoundsState {
  byAsset: Record<string, Vec3>
  set(assetId: string, size: Vec3): void
}

export const useBounds = create<BoundsState>((set) => ({
  byAsset: {},
  set: (assetId, size) =>
    set((s) => (s.byAsset[assetId] ? s : { byAsset: { ...s.byAsset, [assetId]: size } })),
}))
